import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../environment";

const BASE_URL = `${API_BASE_PATH}`;

export interface TodoItem {
  description: string;
  status: string;
  client_id: string;
  updated_at: string;
  user_id: string;
  title: string;
  todo_id: string;
  priority: string;
  due_date: string;
  created_at: string;
  assigned_by: string;
}

export interface FullLeadDetails {
  lead_id?: string;
  LeadIndustry_id?: string;
  tax?: number | null;
  cgst?: number | null;
  proposal_id?: string | null;
  website_url?: string;
  LeadStage_id?: string;
  amount?: number | null;
  revision_id?: string | null;
  quotaiton_id?: string | null;
  lead_description?: string;
  contact_id?: string;
  total_amount?: number | null;
  sgst?: number | null;
  leadowner_id?: string;
  lead_status?: string;
  product_id?: string;
  proposal_discount?: number | null;
  igst?: number | null;
  client_id?: string;
  lead_value?: string;
  product_type_id?: string;
  proposal_discount_percentage?: number | null;
  cgst_percentage?: number | null;
  branch_id?: string;
  Currency?: string;
  customerPotential_id?: string;
  proposal_tax_percentage?: number | null;
  sgst_percentage?: number | null;
  created_at?: string;
  leadtype_id?: string;
  no_logins?: number;
  client_proposal_number?: string | null;
  igst_percentage?: number | null;
  updated_at?: string;
  LeadSource_id?: string;
  rate_per_login?: number;
  total_no_login?: number | null;
  amc?: number | null;
}

export interface CalculateAllUserIncentives {
  id: number;
  user_id: string;
  user_name: string;
  salary: number;
  target: number;
  incentive_target: number;
  total_deal_value: number;
  incentive_achieved_amount: number;
  incentive_percentage: number;
  incentive_level: string;
  calculated_incentive: number;
  created_at: string;
}

export interface MonthlyCounts {
  contacts__this_month: number;
  leads_created_this_month: number;
  deals_created_this_month: number;
  deals_won_this_month: number;
  total_leads_closed: number;
  conversion_rate: number;
  total_revenue_this_month: number;
}

export interface TotalLeadsByStage {
  lead_source_id: string | null;
  lead_source_name: string;
  total_leads: number;
}

export interface TotalLeadsByStageWithDetails {
  lead_stage_id: string | null;
  lead_stage_name: string;
  total_leads: number;
  company_name: string;
  company_mail: string;
  lead_owner_name: string;
}
export interface LeadCountsFunnel {
  total_leads?: number;
  not_contacted_leads?: number;
  closed_leads?: number;
  deals_won?: number;
}
export interface DealSource {
  deal_source_id: string | null;
  deal_source_name: string;
  total_deal: number;
}
export interface DealStatusCount {
  total_deal?: number;
  total_deals_closed?: number;
  total_deals_open?: number;
  total_deals_lost?: number;
  total_deals_won?: number;
}

export interface LeadStats {
  user_name: string;
  calculate_all_user_incentives: CalculateAllUserIncentives;
  calculate_user_incentive: {
    user_id: string;
    user_name: string;
    salary: number;
    target: number;
    incentive_target: number;
    total_deal_value: number;
    incentive_percentage: number;
    calculated_incentive: number;
  };
  lead_summary: {
    status: string;
    lead_count: number;
    total_value: number;
  }[];
  deal_summary: {
    status: string;
    deal_count: number;
    total_value: number;
  }[];
  lead_source: {
    lead_source_id: string | null;
    lead_source_name: string;
    total_leads: number;
    deals?: number;
  }[];
  lead_type: {
    lead_type_id: string | null;
    lead_type_name: string;
    total_leads: number;
  }[];
  product_type: {
    product_id: string | null;
    product_name: string;
    total_leads: number;
  }[];
  conversion_rate: {
    conversion_rate_percent: number;
  };
  todo: {
    created_own: TodoItem[];
    assigned_todo: TodoItem[];
  }[];
  totalLeads: {
    total_leads: number;
    active_leads: number;
  };
  get_leads_by_status_full_details_not_contacted_for_user: FullLeadDetails[];
  get_monthly__counts: MonthlyCounts;
  get_total_leads_by_all_stage: TotalLeadsByStage[];
  get_total_leads_by_all_stage_withdetails_for_user: TotalLeadsByStageWithDetails[];
  get_lead_counts_funnel: LeadCountsFunnel[]; // new funnel format as an array
  get_total_dealsource: DealSource[];         // new data addition
  //get_lead_counts_funnel: { [key: string]: number }[]; // OR LeadCountsFunnel[]
  // get_total_dealsource: DealSource[];
  get_dealstatuscount: { [key: string]: number }[]; // OR DealStatusCount[]
}

// Fetch Lead Stats by User ID
export const fetchLeadStatsByUser = async (userId: string): Promise<LeadStats | null> => {
  try {
    const token = localStorage.getItem("authToken");
    if (!token) {
      console.error("Authentication token missing. Please log in.");
      return null;
    }

    const response = await axios.get(`${BASE_URL}/leads/by-status/${userId}`, {
      headers: {
        Authorization: token,
        Accept: "application/json",
      },
    });

    return response.data as LeadStats;
  } catch (error: any) {
    const message =
      error?.response?.data?.detail || error?.message || "Failed to fetch lead stats";
    console.error(message);
    return null;
  }
};